export default __webpack_public_path__ + "static/media/SurveyorText-Medium.4bcaa758.woff2";